import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectInquiriesState = (state: RootState) => state.inquiries;

export const selectInquiries = createSelector(
  selectInquiriesState,
  (inquiriesState) => inquiriesState.inquiries
);

export const selectSimilarInquiries = createSelector(
  selectInquiriesState,
  (inquiriesState) => inquiriesState.similarInquiries
);
